// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jn-0";
export var fileCarousel = "_jn-2";
export var removeFileButton = "_jn-1";